<template>
  <v-data-table
    :expanded="tableMixin_expandedRows"
    :footer-props="{
      'items-per-page-options': [pagination.per_page],
    }"
    :items-per-page="pagination.per_page"
    :headers="tableMixin_displayedHeaders"
    :items="displayedItems"
    :mobile-breakpoint="0"
    :page="pagination.current_page"
    :server-items-length="pagination.total"
    :class="{ 'content-loading': loading }"
    disable-sort
    @update:page="tableMixin_changePage"
    @click:row="tableMixin_onRowClick"
  >
    <template v-slot:item.image="{ item }">
      <v-img
        v-if="item.image_path"
        :src="$backendUrl(item.image_path)"
        :alt="item.original_name"
        height="100px"
        width="100px"
        class="clickable"
        contain
        @click.stop="viewImages(item)"
      />
    </template>

    <template v-slot:item.active="{ item }"> {{ item.start_at }} - {{ item.end_at }} </template>

    <template v-slot:item.url_link="{ item }">
      <a :href="item.url_link" class="link" target="_blank">
        {{ item.url_link }}
      </a>
    </template>

    <template v-slot:item.actions="{ item }">
      <BaseActionMenu :actions="getRowActions(item)" :item="item" />
    </template>

    <template v-slot:expanded-item="{ item }">
      <BaseExpandedTableRow
        :colspan="tableMixin_displayedHeaders.length"
        :headers="tableMixin_hiddenHeaders"
        :item="item"
      >
        <template v-slot:item.active> {{ item.start_at }} - {{ item.end_at }} </template>

        <template v-slot:item.url_link>
          <a :href="item.url_link" class="link" target="_blank">
            {{ item.url_link }}
          </a>
        </template>
      </BaseExpandedTableRow>
    </template>
  </v-data-table>
</template>

<script>
import tableMixin from '../mixins/table-mixin';
import BaseActionMenu from './base/BaseActionMenu';
import BaseExpandedTableRow from './base/BaseExpandedTableRow';

export default {
  name: 'PopupBannerTable',

  components: {
    BaseExpandedTableRow,
    BaseActionMenu,
  },

  mixins: [tableMixin],

  props: {
    items: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('image'),
          value: 'image',
        },
        {
          text: this.$t('url_link'),
          value: 'url_link',
          hidden: 'xsOnly',
        },
        {
          text: this.$t('active'),
          value: 'active',
          hidden: 'xsOnly',
        },
        {
          value: 'actions',
          align: 'end',
        },
      ];
    },

    displayedItems() {
      if (!this.items) {
        return [];
      }
      return this.items.map((r) => ({
        ...r,
      }));
    },
  },

  methods: {
    getRowActions() {
      const actions = [
        {
          callback: (p) => this.$emit('edit', p),
          label: this.$t('edit'),
          icon: 'mdi-pencil',
        },
        {
          callback: (p) => this.$emit('delete', p),
          label: this.$t('delete'),
          icon: 'mdi-delete',
        },
      ];
      return actions;
    },
  },
};
</script>
